import { render, staticRenderFns } from "./ExportedList.vue?vue&type=template&id=2e190df4&scoped=true&"
import script from "./ExportedList.vue?vue&type=script&lang=js&"
export * from "./ExportedList.vue?vue&type=script&lang=js&"
import style0 from "./ExportedList.vue?vue&type=style&index=0&id=2e190df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e190df4",
  null
  
)

export default component.exports